import { useEffect, useState, useCallback, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useSEO from '../../hooks/useSEO';

import '../Main/Main.css';
import avatar from '../../assets/logo-beta-1.png';
import img_1 from '../../assets/img_1.png';
import img_2 from '../../assets/img_2.png';
import fundo from '../../assets/fundo.jpg';

import site_img_1 from '../../assets/fundoFlor2.png';
import img_vero from '../../assets/vero.png';
import img_paygo from '../../assets/paygo-1.png';
import img_pagSeg from '../../assets/pagseg.png';
import img_stone from '../../assets/stone.png';



import img_server from '../../assets/fundoFlor1.png';
import img_cadprod from '../../assets/cadprod.webp';
import img_impnota from '../../assets/impnota.webp';
import img_controlecx from '../../assets/controlecx.webp';
import img_whatsapp from '../../assets/img-whatsapp.png';

import InputMask from 'react-input-mask';
import api from '../../services/api';
import { toast } from 'react-toastify';

import { isMobile } from 'react-device-detect';
import { FaBoxArchive, FaClipboardList, FaCloud, FaMoneyBillTransfer, FaRegClock, FaTruck, FaUsersGear } from 'react-icons/fa6';

import { CiBoxes } from 'react-icons/ci';
import { GiBookshelf, GiFlowerPot, GiNotebook } from 'react-icons/gi';
import { PiNotepadFill } from 'react-icons/pi';
import { BsBuildingsFill, BsGiftFill } from 'react-icons/bs';
import { IoIosPricetags } from 'react-icons/io';
import { LuBoxes, LuSendToBack } from 'react-icons/lu';
import { MdAutoFixHigh, MdImportantDevices, MdSwitchAccount } from 'react-icons/md';
import { FaRegCalendarAlt, FaShoppingBasket } from 'react-icons/fa';
import { GrWorkshop } from 'react-icons/gr';
import { LiaCashRegisterSolid } from 'react-icons/lia';
import { TbFileTypeXml } from 'react-icons/tb';
import { RiScales2Fill, RiWifiOffLine } from 'react-icons/ri';
import { TiPrinter } from 'react-icons/ti';
import { GrContactInfo } from 'react-icons/gr';
import nfe_icon from '../../assets/nfe_icon.png';
import pos_terminal from '../../assets/pos-terminal.png';
import { HiUserGroup } from 'react-icons/hi';


const PhoneInput = ({ className, ...props }) => {
  const [mask, setMask] = useState("(99) 99999-9999");

  return (
    <InputMask
      {...props}
      mask={mask}
      onBlur={e => {
        if (e.target.value.replace("_", "").length === 14) {
          setMask("(99) 9999-9999");
        }
      }}
      onFocus={e => {
        if (e.target.value.replace("_", "").length === 14) {
          setMask("(99) 99999-9999");
        }
      }}
    >
      {inputProps => <input {...inputProps} type="tel" />}
    </InputMask>
  );
};


export default function Floricultura({ children, name }) {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [nome, setNome] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [hwidth, setHwidth] = useState(window.innerWidth);
  const [contatoPage, setContatoPage] = useState(1);
  const [isWhats, setIsWhats] = useState(false);
  const [showDiv, setShowDiv] = useState(false);
  const [info, setInfo] = useState("");

  useSEO(
    'Sistema para Floriculturas - Gestão de Vendas e Estoque',
    'Potencialize sua floricultura com a BeiTec: controle de pedidos, gestão de estoque de flores e plantas, e emissão rápida de notas fiscais. Tudo em nuvem.'
  );

  useEffect(() => {
    function handleResize() {
      setHwidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [hwidth]);

  useEffect(() => {
    let temp_hwidth = hwidth;
    if (temp_hwidth < 620) {
      if (!isMobile) { setIsMobile(true) }
    } else {
      if (isMobile) { setIsMobile(false) }

    }
    // toast.success(temp_hwidth)
  }, [hwidth]);

  function apenasNumeros(_string) {
    if (_string.match(/^[0-9\-\_\(\)\" "]+$/) != null) {
      return true;
    } else {
      return false;
    }
  }


  useEffect(() => {
    if (email.length >= 2 && apenasNumeros(email) == true) {
      if (isWhats == false) {
        setIsWhats(true);
      }
    } else {
      if (isWhats == true) {
        setIsWhats(false);
      }
    }
  }, [email]);


  function enviarForm(estado = "") {
    setContatoPage(4)
    envia(estado);
  }

  function contato(id = "", autoFocus = false) {


    return (<>
      <div className="fundo" >
        <div className="info-box" style={{ width: "auto", minWidth: "410px", height: "auto" }}>
          <div className="col_a">
            {contatoPage <= 1 && <>
              <img width="64" height="64"
                src="https://img.icons8.com/external-nawicon-outline-color-nawicon/64/external-Agreement-business-management-nawicon-outline-color-nawicon.png" />
            </>}
            {contatoPage == 2 && <>
              <img width="64" height="64" src="https://img.icons8.com/fluency/48/company.png" alt="company" />
            </>}
          </div>
          <div className="col_full">
            <div className="sibe-content-title" style={{ width: "auto", textAlign: "center" }}>
              {contatoPage == 1 ? <>
                <p className="title-bar-texto" style={{ color: "black", fontSize: "16px" }}>Nós entramos em contato com você!</p>
                <div className="edit-mail">
                  {email.length <= 1 ? <>
                    <img width="30" height="30" src="https://img.icons8.com/color/48/chat--v1.png" alt="chat--v1" />
                  </> :
                    email.length >= 2 && apenasNumeros(email) == true ? <>
                      <img width="30" height="30" src="https://img.icons8.com/color/48/whatsapp--v1.png" style={{ marginTop: "-1px" }} />
                    </> : <>
                      <img width="28" height="28" src="https://img.icons8.com/fluency/48/mail.png" style={{ marginLeft: "2px" }} />
                    </>}

                  {isWhats ? <>
                    <PhoneInput name={id} id={id} style={{ textAlign: "center", border: "none", width: "100%" }} value={email} onChange={e => { setEmail(e.target.value) }} autoFocus={autoFocus} />
                  </> : <>
                    <input name={id} id={id} className="edit-mail-input" style={{ textAlign: "center" }}
                      value={email} onChange={e => { setEmail(e.target.value) }} placeholder='informe seu WhatsApp ou Email' />
                  </>}



                  <button className='btn-ok' onClick={() => { if (email.length > 5) { setContatoPage(2) } }} >OK</button>
                </div>
              </> : contatoPage == 2 ? <>
                <p className="title-bar-texto" style={{ color: "black", fontSize: "16px" }}>Qual o nome da sua empresa?</p>
                <div className="edit-mail">
                  <input className="edit-mail-input" style={{ textAlign: "center", margin: "5px" }}
                    value={nome} onChange={e => { setNome(e.target.value) }} placeholder='nome da empresa' />

                  <button className='btn-ok' onClick={() => { if (nome.length > 2) { setContatoPage(3); } }} >OK</button>
                </div>
              </> : contatoPage == 3 ? <>
                <p className="title-bar-texto" style={{ color: "black", fontSize: "16px" }}>Para conluir, clique no estado de atuação.</p>
                <div className="seletor-estado">
                  <button className="btn-estado" onClick={() => { enviarForm("AC") }} >AC</button>
                  <button className="btn-estado" onClick={() => { enviarForm("AL") }} >AL</button>
                  <button className="btn-estado" onClick={() => { enviarForm("AP") }} >AP</button>
                  <button className="btn-estado" onClick={() => { enviarForm("AM") }} >AM</button>
                  <button className="btn-estado" onClick={() => { enviarForm("BA") }} >BA</button>
                  <button className="btn-estado" onClick={() => { enviarForm("CE") }} >CE</button>
                  <button className="btn-estado" onClick={() => { enviarForm("DF") }} >DF</button>
                  <button className="btn-estado" onClick={() => { enviarForm("ES") }} >ES</button>
                  <button className="btn-estado" onClick={() => { enviarForm("GO") }} >GO</button>
                  <button className="btn-estado" onClick={() => { enviarForm("MA") }} >MA</button>
                  <button className="btn-estado" onClick={() => { enviarForm("MT") }} >MT</button>
                  <button className="btn-estado" onClick={() => { enviarForm("MS") }} >MS</button>
                  <button className="btn-estado" onClick={() => { enviarForm("MG") }} >MG</button>
                  <button className="btn-estado" onClick={() => { enviarForm("PA") }} >PA</button>
                  <button className="btn-estado" onClick={() => { enviarForm("PB") }} >PB</button>
                  <button className="btn-estado" onClick={() => { enviarForm("PR") }} >PR</button>
                  <button className="btn-estado" onClick={() => { enviarForm("PI") }} >PI</button>
                  <button className="btn-estado" onClick={() => { enviarForm("RJ") }} >RJ</button>
                  <button className="btn-estado" onClick={() => { enviarForm("RN") }} >RN</button>
                  <button className="btn-estado" onClick={() => { enviarForm("RS") }} >RS</button>
                  <button className="btn-estado" onClick={() => { enviarForm("RO") }} >RO</button>
                  <button className="btn-estado" onClick={() => { enviarForm("RR") }} >RR</button>
                  <button className="btn-estado" onClick={() => { enviarForm("SC") }} >SC</button>
                  <button className="btn-estado" onClick={() => { enviarForm("SP") }} >SP</button>
                  <button className="btn-estado" onClick={() => { enviarForm("SE") }} >SE</button>
                  <button className="btn-estado" onClick={() => { enviarForm("TO") }} >TO</button>
                </div>
              </> : <div style={{ height: "100px", width: "420px", display: "flex", flexDirection: "column", justifyContent: 'center', alignItems: "center", gap: "20px" }}>

                <p>Obrigado, em breve entraremos em contato.</p>
                <img width="48" height="48" src="https://img.icons8.com/color/48/checked--v1.png" alt="checked--v1" />
              </div>

              }

            </div>
          </div>
        </div>
      </div>
    </>)
  }

  function itemT(nome, cor) {
    return (<>
      <div style={{
        width: "auto", maxHeight: "20px", display: "flex", borderRadius: "10px", padding: "11px",
        justifyContent: "center", alignItems: "center", backgroundColor: cor, color: "white"
      }}>
        {nome}
      </div>
    </>)
  }

  async function envia(uf) {
    try {
      const resp = await api.post(`/beitecForm`, {
        code: String("SITE_MAIN"),
        form: String("A00001"),
        nome: String(nome),
        email: String(email),
        fone: String(""),
        whats: String(email),
        aux_a: String('concordo'),
        aux_b: String(uf),
      });
      //alert(JSON.stringify(resp.data));
      if ((resp.data.message) == "OK") {
        return;
      }
    } catch (e) {
      // toast.error('Erro.. '+e);
    }
  }

  function boxRoxo(texto, icon = 0) {
    return (
      <div className='fundo-box-roxo' style={{
        width: isMobile ? "180px" : "240px", height: isMobile ? "100px" : "100px",
        padding: "15px", display: "flex",
        justifyContent: "center", alignItems: "center", textAlign: "center",
        flexDirection: "column"
      }}>
        {icon == "NFE" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><img src={nfe_icon} style={{ width: "auto", height: "55px" }} /></div>}
        {icon == "XML" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><TbFileTypeXml size={30} /></div>}
        {icon == "CAIXA" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><LiaCashRegisterSolid size={30} /></div>}
        {icon == "LIVROS" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><GiBookshelf size={30} /></div>}
        {icon == "ESTOQUE" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><CiBoxes size={30} /></div>}
        {icon == "ENCOMENDAS" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><FaTruck size={30} /></div>}
        {icon == "FICHA" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><GiNotebook size={30} /></div>}
        {icon == "COMANDA" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><PiNotepadFill size={30} /></div>}
        {icon == "GIFT" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><BsGiftFill size={30} /></div>}
        {icon == "ETIQUETA" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><IoIosPricetags size={30} /></div>}
        {icon == "CONSIG" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><LuBoxes size={30} /></div>}
        {icon == "CONTAS" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><FaMoneyBillTransfer size={30} /></div>}
        {icon == "AGENDA" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><FaRegCalendarAlt size={30} /></div>}
        {icon == "PRODUCAO" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><GrWorkshop size={30} /></div>}
        {icon == "CLOUD" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><FaCloud size={30} /></div>}

        {icon == "SO" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><MdImportantDevices size={30} /></div>}
        {icon == "MULTI" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><BsBuildingsFill size={30} /></div>}
        {icon == "USER" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><FaUsersGear size={30} /></div>}
        {icon == "OFFLINE" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><RiWifiOffLine size={30} /></div>}
        {icon == "ENTRE_FILIAL" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><LuSendToBack size={30} /></div>}

        {icon == "IMPRESSORAS" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><TiPrinter size={30} /></div>}
        {icon == "CADASTROS" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><GrContactInfo size={30} /></div>}
        {icon == "PRECOS" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><MdAutoFixHigh size={30} /></div>}
        {icon == "PONTO" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><FaRegClock size={30} /></div>}

        {icon == "LISTAS" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><FaClipboardList size={30} /></div>}
        {icon == "BALANCA" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><RiScales2Fill size={30} /></div>}
        {icon == "CONVENIO" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><HiUserGroup size={30} /></div>}
        {icon == "PDV" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><FaShoppingBasket size={30} /></div>}

        {icon == "SMART_POS" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><img src={pos_terminal} style={{ width: "auto", height: "32px" }} /></div>}
        {icon == "TEF" && <div style={{ minWidth: "31px", marginTop: "-5px" }}><img src={pos_terminal} style={{ width: "auto", height: "32px" }} /></div>}

        <p style={{ color: "rgb(38, 79, 144)", fontSize: isMobile ? "15px" : "16px", }}>{texto}</p>
      </div>)
  }

  return (
    <>

      <div className="app-content" >
        <img src={img_server} style={{ width: "100%", height: "100%", objectFit: "cover", top: 0, position: "fixed", zIndex: -1 }} />

        <div style={showDiv ? {} : {
          position: "absolute", right: 0, bottom: 0, margin: "15px", marginRight: "45px", marginBottom: "50px", cursor: "pointer", zIndex: 999999,
        }}
          onClick={() => { window.open("https://api.whatsapp.com/send?phone=555195555616", "WhatsApp"); }}>
          <div style={{
            backgroundColor: "rgb(35, 74, 35)", height: "45px", gap: "10px", width: "100%", textAlign: "center", paddingLeft: "18px", borderRadius: "18px",
            paddingRight: "18px", display: "flex", alignItems: "center", color: "white", border: "2px solid rgb(55, 131, 46)", justifyContent: "space-between"
          }}

          ><img src={img_whatsapp} style={{ width: "42px", height: "42px", top: "calc(100% - 95px)", left: 0, }} />Fale com um consultor</div>
        </div>

        <div className="title-bar" style={{ backgroundColor: "white", display: "flex", justifyContent: "space-between" }}>
          {/*  <div className="sibe-content-avatar"><img src={avatar}  ></img>  </div> */}
          <div className="sibe-content-title">
            <p className="title-bar-texto" style={{ color: "#46619D", fontSize: "28px", cursor: "pointer" }}>BeiTec</p>

          </div>
          <p style={{
            border: "1px solid blue", backgroundColor: "white", display: "flex", alignItems: "center", padding: "10px", paddingLeft: "28px", paddingRight: "28px",
            borderRadius: "18px", marginLeft: "-170px", margin: "8px", marginRight: "15px", minWidth: "135px",
            justifyContent: "center", cursor: "pointer"
          }} onClick={() => {
            // window.open("/planos/");
            navigate("/planos")
          }} >ver planos</p>
          {!isMobile && <>

            <div style={{
              backgroundColor: "rgba(0, 71, 146)", margin: "8px", marginRight: "15px", textAlign: "center", paddingLeft: "28px", borderRadius: "18px", width: "200px",
              paddingRight: "28px", display: "flex", alignItems: "center", cursor: "pointer", color: "white", border: "2px solid rgb(13, 104, 202)"
            }}
              onClick={() => { window.open("https://api.whatsapp.com/send?phone=555195555616", "WhatsApp"); }}
            ><p style={{ width: "100%" }}>Quero saber mais</p></div></>}
        </div>
        {/* #0F74BD   #004692  rgb(0, 70, 146) */}

        <div style={{
          width: "100%", height: isMobile ? "205px" : "317px", backgroundColor: "rgba(0, 71, 146, 0.7)", display: "flex",
          justifyContent: "center", alignItems: "center"
        }}>
          <p style={{
            fontSize: isMobile ? "25px" : "72px", color: "white", fontWeight: 600,
            maxWidth: "990px", textAlign: "center",
          }}>vender, emitir e controlar nunca foi tão fácil</p>
        </div>

        <div style={{
          width: "100%", height: isMobile ? "auto" : "481px", position: "relative", display: "flex",
          flexDirection: isMobile ? "column" : "row",
        }}>

          <div style={{
            height: isMobile ? "auto" : "100%", width: isMobile ? "100%" : "50%",
            gap: isMobile ? "5px" : "120px", backgroundColor: "white", display: "flex",
            flexDirection: "column",
            alignItems: "center", justifyContent: isMobile ? "space-around" : "center"
          }}>

            <p style={{
              fontSize: isMobile ? "17px" : "29px", minHeight: "70px", color: "#000000", fontWeight: 600,
              maxWidth: "430px", textAlign: "center", color: "rgb(0, 33, 91)"
            }}>Somos integrados a diversos meios de pagamento
              <p style={{ fontSize: "14px", marginTop: "12px", color: "rgb(6, 64, 163)" }}>Via TEF e Smart POS</p></p>

            <div style={{
              width: "100%", gap: isMobile ? "8px" : "25px", height: isMobile ? "auto" : "72px", padding: "5px", display: "flex",
              justifyContent: "center", flexWrap: "wrap",
              backgroundColor: "rgba(213, 210, 226, 0.74)",
            }}>
              <img src={img_stone} style={{ width: "120px", height: "60px", top: "calc(100% - 95px)", left: 0, }} />
              <img src={img_vero} style={{ width: "200px", height: "60px", top: "calc(100% - 95px)", left: 220, }} />
              <img src={img_pagSeg} style={{ width: "160px", height: "60px", marginTop: "12px", maxHeight: "40px", top: "calc(100% - 95px)", left: 440, }} />
              <img src={img_paygo} style={{ width: "120px", height: "60px", marginTop: "5px", top: "calc(100% - 95px)", left: 660, }} />
            </div>
          </div>
          <img src={site_img_1} style={{ width: isMobile ? "100%" : "50%", height: isMobile ? "230px" : "100%", objectFit: "cover", objectPosition: "10% 45%", }} />
        </div>


        <div style={{
          minHeight: "800px", backgroundColor: "rgba(255, 255, 255, 0.95)", display: "flex",
          justifyContent: "center", alignItems: "center"
        }}>

          <GiFlowerPot size={95} color='rgb(0, 170, 255)' />
        </div>






        <div style={{ height: "45px", width: "100%", backgroundColor: "#7c797974", display: "flex", color: "white", gap: "25px", padding: "15px", alignItems: "center" }}>
          <p>BeiTec ® 2024 </p>
          <p>32.411.090/0001-08</p>

        </div>
      </div>

    </>
  )
}
